module.exports = __webpack_public_path__ + "static/img/Red_Envelope.e518c93f.png";